(function ($, window) {
    'use strict';

    $(function () {
        const $media = $('.js-media');
        const pausedClass = 'is-paused';

        if (!$media.length) return;

        $media.each(function () {
            const $this = $(this);
            const $video = $this.find('.js-media-video');
            const $toggle = $this.find('.js-media-video-toggle');

            if (!$video.length || !$toggle.length) return;

            $toggle.on('click', function () {
                var video = $video[0];

                if (video.paused) {
                    video.play();
                    $this.removeClass(pausedClass);
                    $toggle.attr('aria-label', 'Pause video');
                } else {
                    video.pause();
                    $this.addClass(pausedClass);
                    $toggle.attr('aria-label', 'Play video');
                }
            });
        });
    });
})(jQuery, window);
